import { lazy, Suspense } from "react";
import { Loader } from "@/components";
const AuthLayout = lazy(() => import("@/layouts/Auth.layout"));
const Login = lazy(() => import("@/pages/Login.page"));
const Register = lazy(() => import("@/pages/Register.page"));
const SuccessPage = lazy(() => import("@/pages/Success.page"));
const RestorePassReq = lazy(() => import("@/pages/RestorePassReq.page"));
const RestorePass = lazy(() => import("@/pages/RestorePass.page"));
const MfaConfirmEmail = lazy(() => import("@/pages/MfaConfirmEmail.page"));

const authRoute = [
  {
    path: "sign-in",
    element: (
      <Suspense fallback={<Loader />}>
        <AuthLayout />
      </Suspense>
    ),
    children: [
      {
        index: true,
        element: (
          <Suspense fallback={<Loader />}>
            <Login />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: "sign-up",
    element: (
      <Suspense fallback={<Loader />}>
        <AuthLayout />
      </Suspense>
    ),
    children: [
      {
        index: true,
        element: (
          <Suspense fallback={<Loader />}>
            <Register />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: "/success",
    element: (
      <Suspense fallback={<Loader />}>
        <SuccessPage />
      </Suspense>
    ),
  },
  {
    path: "/restore-pass-req",
    element: (
      <Suspense fallback={<Loader />}>
        <RestorePassReq />
      </Suspense>
    ),
  },
  {
    path: "/restore-pass/:token",
    element: (
      <Suspense fallback={<Loader />}>
        <RestorePass />
      </Suspense>
    ),
  },
  {
    path: "/mfa/confirm-email",
    element: (
      <Suspense fallback={<Loader />}>
        <MfaConfirmEmail />
      </Suspense>
    ),
  },
];
export default authRoute;
